/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { BaseLayout } from "Views/scaffolding/layouts/base";
import { Main } from "Views/scaffolding/layouts/main/main";

type Props = React.PropsWithChildren<{}>;

function GenericLayout(props: Props): JSX.Element {
  return (
    <BaseLayout>
      <Main>{props.children}</Main>
    </BaseLayout>
  );
}

const genericLayoutMemo = React.memo<Props>(GenericLayout);
export { genericLayoutMemo as GenericLayout };
